import { useMutation } from "@tanstack/react-query";
import { Form, Formik } from "formik";
import { Col, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import BackButton from "../../../Components/BackButton";
import { showToast } from "../../../Components/Toast/toast";
import withModal from "../../../HOC/withModal";
import { usePageTitle } from "../../../Hooks/usePageTitle";
import { passwordUpdate } from "../../../Services/Affiliate/Dashboard";
import { isNullOrEmpty } from "../../../Utils/Utils";
import { changePasswordSchema } from "../../../Utils/Validations/ValidationSchemas";
import TextInput from "../../../Components/TextInput";
import CustomButton from "../../../Components/CustomButton";

const ChangePassword = ({ showModal }) => {
  usePageTitle("Change Password");

  const navigate = useNavigate();

  const updatePasswordMutation = useMutation({
    mutationFn: passwordUpdate,
    onSuccess: () => {
      showToast("Password Updated Successfully", "success");
      navigate("/affiliate/profile");
    },
    onError: (error) => {
      showToast("Failed to update password", "error");
    },
  });

  const handleChangePasswordSubmit = (values) => {
    updatePasswordMutation.mutate(values);
  };

  return (
    <section className="profile-management">
      <div className="admin-content-header mb-4 d-flex gap-2">
        <BackButton />
        <h2 className="screen-title mb-0">Change Password</h2>
      </div>

      <div className="admin-content-body rounded-20 p-4 p-lg-4 p-xxl-4 mb-4">
        <Row>
          <Col md={10} lg={8} xl={6} xxl={5}>
            <div className="change-password-form">
              <Formik
                initialValues={{
                  current_password: "",
                  password: "",
                  password_confirmation: "",
                }}
                validationSchema={changePasswordSchema}
                onSubmit={handleChangePasswordSubmit}
              >
                {({ values, errors, touched, handleChange, handleBlur }) => (
                  <Form>
                    <Row>
                      <Col xs={12} className="mb-3 mb-lg-4 mb-xxl-4">
                        <TextInput
                          name={"current_password"}
                          type={"password"}
                          required
                          label={"Current Password"}
                          placeholder={"Enter Current Password"}
                          value={values.current_password}
                          labelClassName={`label-padding-left`}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={touched.current_password && errors.current_password}
                        />
                      </Col>
                      <Col xs={12} className="mb-3 mb-lg-4 mb-xxl-4">
                        <TextInput
                          name={"password"}
                          type={"password"}
                          required
                          label={"New Password"}
                          placeholder={"Enter New Password"}
                          value={values.password}
                          labelClassName={`label-padding-left`}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={touched.password && errors.password}
                        />
                      </Col>
                      <Col xs={12} className="mb-3 mb-lg-4 mb-xxl-4">
                        <TextInput
                          name={"password_confirmation"}
                          type={"password"}
                          required
                          label={"Confirm Password"}
                          placeholder={"Confirm password"}
                          value={values.password_confirmation}
                          labelClassName={`label-padding-left`}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={
                            touched.password_confirmation &&
                            errors.password_confirmation
                          }
                        />
                      </Col>
                    </Row>

                    <Row className="mt-4">
                      <Col xs={12}>
                        <CustomButton
                          type="submit"
                          text={"Update"}
                          loadingText="Updating..."
                          className="min-width-220"
                        />
                      </Col>
                    </Row>
                  </Form>
                )}
              </Formik>
            </div>
          </Col>
        </Row>
      </div>
    </section>
  );
};
export default withModal(ChangePassword);
